import Authentication from "../authentication/Authentication";
import Permissions from "../authentication/Permissions";

const auth = new Authentication();

export default class AuthorizationService {
    static getInstance() {
        return auth;
    }


    static getRolePermissions = function (inRole) {
        let permissionGroup = {
            accountService: [
                Permissions.account.edit,
                Permissions.subscription.edit,
                Permissions.account.isInternal.edit
            ],
            userService: [
                Permissions.user.add,
                Permissions.user.edit,
                Permissions.user.changeStatus
            ],
            subscriptionService: [
                Permissions.subscription.edit
            ],
            productService: [
                Permissions.product.add,
                Permissions.product.edit,
                Permissions.product.delete
            ],
            adminService: [
                Permissions.account.add,
                Permissions.account.changeStatus,
                Permissions.subscription.add,
                Permissions.subscription.changeStatus,
                Permissions.subscription.delete
            ]

        }
        let roles =
            {
                ROLE_ADMINISTRATOR: {
                    role: "ROLE_ADMINISTRATOR",
                    permissions: [...permissionGroup.accountService, ...permissionGroup.productService,
                        ...permissionGroup.userService, ...permissionGroup.adminService, ...permissionGroup.subscriptionService]
                },
                ROLE_DEVELOPER: {
                    role: "ROLE_DEVELOPER",
                    permissions: [...permissionGroup.accountService, ...permissionGroup.productService,
                        ...permissionGroup.userService, ...permissionGroup.adminService, ...permissionGroup.subscriptionService]
                },
                ROLE_CUSTOMER_SERVICE: {
                    role: "ROLE_CUSTOMER_SERVICE",
                    permissions: [...permissionGroup.accountService, ...permissionGroup.subscriptionService, ...permissionGroup.userService]
                },
                ROLE_PRODUCT_MANAGER: {
                    name: "ROLE_PRODUCT_MANAGER",
                    permissions: [...permissionGroup.accountService, ...permissionGroup.productService,
                        ...permissionGroup.userService, ...permissionGroup.subscriptionService]
                },
                ROLE_UNAUTHORIZED: {
                    name: "ROLE_UNAUTHORIZED"
                }
            }
        return roles[inRole].permissions
    }

    /**
     * Determines whether the current user is allowed to modify or change the roles being added.
     * Currently, if the product is User Management Tool we don't want customer service or product managers to be able to elevalte their privileges to developer or admin.
     * @param role
     */
    static canAddRole(productName, role) {
        //If this is not user manager product allow role addition for all other apps
        if (productName !== "usermanager") return true
        let user = auth.getUser()
        //Administrators can add any role
        if (user.roles.includes("ROLE_ADMINISTRATOR")) return true
        //Not an admin, but role is above their allowed user change
        if (role === "ROLE_ADMINISTRATOR" || role === "ROLE_DEVELOPER") return false
        if (["ROLE_PRODUCT_MANAGER", "ROLE_CUSTOMER_SERVICE"].includes(role) && user.roles.includes("ROLE_PRODUCT_MANAGER")) return true
        if (role === "ROLE_CUSTOMER_SERVICE" && user.roles.includes("ROLE_CUSTOMER_SERVICE")) return true
        return false

        //Currently not handling developer role - just because it is a silly role in the first place that needs to be replaced.  Developers should be admin

    }

    static hasPermission(permission) {
        let user = auth.getUser()
        for (let i = 0; i < user.roles.length; i++) {
            const role = user.roles[i];
            let permissions = this.getRolePermissions(role)
            if (permissions.includes(permission)) return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/services/authorization-service.js